import * as React from 'react';

/** Lets sections rendered through `availableBody` speak through the picker's own live region. */
export const ListPickerAnnounceContext = React.createContext<(message: string) => void>(() => undefined);

export const useListPickerAnnounce = (): ((message: string) => void) => React.useContext(ListPickerAnnounceContext);
